export default {
  data: () => ({
    translations: {
      no: {
        el: 'Όχι',
        en: 'No',
        it: 'No',
      },
      code: {
        el: 'Κωδικός',
        en: 'Code',
        it: 'Code',
      },
      name: {
        el: 'Όνομα',
        en: 'Name',
        it: 'Nome',
      },
      orderBy: {
        el: 'Ταξινόμηση κατά',
        en: 'Order By',
        it: 'Ordinato da',
      },
      orderPriority: {
        el: 'Προτεραιότητα παραγγελίας',
        en: 'Order Priority',
        it: "Priorità dell'Οrdine",
      },
      activeUsers: {
        el: 'Ενεργοί Χρήστες (με συναλλαγές)',
        en: 'Active Users (with transactions)',
        it: 'Utenti attivi (con transazioni)',
      },
      uniqueUsers: {
        el: 'Σύνολο Μοναδικών Χρηστών',
        en: 'All Unique Users',
        it: 'Utenti unici totali',
      },
      uniqueUsersTwoMonths: {
        el: '*μοναδικοί χρήστες τους τελευταίους 2 μήνες',
        en: '*unique users in the last 2 months',
        it: '*utenti unici negli ultimi 2 mesi',
      },
      totalAmount: {
        el: 'Τελικό Ποσό',
        en: 'Total Amount',
        it: 'Importo totale',
      },
      transactions: {
        el: 'Συναλλαγές',
        en: 'Total Transactions',
        it: 'Transazione totale',
      },
      total_points: {
        el: 'Πόντοι',
        en: 'Total Points',
        it: 'Punti',
      },
      total_cashback: {
        el: 'Cashback',
        en: 'Total Cashback',
        it: 'Rimborso Totale',
      },
      users: {
        el: 'Χρήστες',
        en: 'Total Users',
        it: 'Utenti totale',
      },
      region: {
        el: 'Περιφέρεια',
        en: 'Region',
        it: 'Regione',
      },
      endDate: {
        el: 'Τελευταία Ημ/νία',
        en: 'End Date',
        it: 'Ultimo Αppuntamento',
      },
      startDate: {
        el: 'Αρχική Ημ/νία',
        en: 'Start Date',
        it: "Data d'inizio",
      },
      isCompany: {
        el: 'Είναι εταιρεία',
        en: 'Is Company',
        it: "È un'azienda",
      },
      cards: {
        el: 'Κάρτες ανά Κατάστημα',
        en: 'Cards per Store',
        it: 'Carte per Negozio',
      },
      activeTotalUsers: {
        el: 'Ενεργοί Χρήστες',
        en: 'Total Active users',
        it: 'Utenti Attivi',
      },
      totalLoyaltyCardsActivated: {
        el: 'Κάρτες',
        en: 'Total Cards Activated',
        it: 'Totale Tessere Attivate',
      },
      paginationText: {
        el: 'από',
        en: 'of',
        it: 'di',
      },
      showTransactionsMadeBy: {
        el: '',
        en: 'Show Transactions made by',
        it: '',
      },
      search: {
        el: 'Αναζήτηση',
        en: 'Search',
        it: 'Cerca',
      },
      searchInput: {
        el: 'κείμενο αναζήτησης',
        en: 'search text',
        it: 'cerca input',
      },
    },
  }),
};
